import routerConstants from '@/const/routerConstants';
import router from '.';
import store from '@/store/index';

export default [
  // 신청서 전체 메뉴
  {
    name: routerConstants.ApplicationMenu,
    path: '/applicationMenu',
    component: () => import('@/views/application/menu/ApplicationMenuView'),
  },
  // 취소 신청서 메뉴 (근태|보상휴가)
  {
    name: routerConstants.CancelMenu,
    path: '/cancelMenu',
    component: () => import('@/views/application/menu/CancelMenuView'),
  },
  // 근태 코드 선택 (근태명)
  {
    name: routerConstants.GntTypeMenu,
    path: '/gntTypeMenu',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/menu/GntTypeMenuView'),
    props: true,
  },
  // 근태 구분 선택
  {
    name: routerConstants.GntGubunMenu,
    path: '/gntGubunMenu',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/menu/GntGubunMenuView'),
    props: true,
  },
  // 제증명 종류 선택
  {
    name: routerConstants.CertiTypeMenu,
    path: '/certiTypeMenu',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/menu/CertiTypeMenuView'),
    props: true,
  },
  // 날짜 선택 (시작일자)
  {
    name: routerConstants.StartDate,
    path: '/startDate',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/StartDateView'),
    props: true,
  },
  // 날짜 선택 (종료일자)
  {
    name: routerConstants.EndDate,
    path: '/endDate',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/EndDateView'),
    props: true,
  },
  // 시간 선택
  {
    name: routerConstants.SelectTime,
    path: '/selectTime',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/SelectTimeView.vue'),
  },
  // 연장근무신청 시간확인 (근무후신청)
  {
    name: routerConstants.ConfirmOtWorkTime,
    path: '/confirmOtWorkTime',
    meta: { cancelBtn: true },
    component: () =>
      import('@/views/application/form/ConfirmOtWorkTimeView.vue'),
  },
  // 연장근무신청 - 대체휴가 설정
  {
    name: routerConstants.SelectAlterDate,
    path: '/selectAlterDate',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/SelectAlterDateView.vue'),
  },
  // 근무스케줄신청 - 근무스케줄 선택
  {
    name: routerConstants.SelectSchedule,
    path: '/selectSchedule',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/SelectScheduleView.vue'),
  },
  // 제증명서 신청 - 제증명서 옵션선택
  {
    name: routerConstants.SelectCertiOptions,
    path: '/selectCertiOptions',
    meta: { cancelBtn: true },
    component: () =>
      import('@/views/application/form/SelectCertiOptionsView.vue'),
  },
  // 출장신청 - 출장내용작성
  {
    name: routerConstants.BizTripTypeMenu,
    path: '/bizTripTypeMenu',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/menu/BizTripTypeMenuView.vue'),
  },
  // 출장신청 - 출장동행자 선택
  {
    name: routerConstants.SelectBizTripJoiner,
    path: '/selectBizTripJoiner',
    meta: { cancelBtn: true },
    component: () =>
      import('@/views/application/form/SelectBizTripJoinerView.vue'),
  },

  // 결재라인
  {
    name: routerConstants.ApprovalLine,
    path: '/approvalLine',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/ApprovalLineView.vue'),
  },
  // 추가 옵션 (비고, 파일)
  {
    name: routerConstants.ExtraOptions,
    path: '/extraOptions',
    meta: { cancelBtn: true },
    component: () => import('@/views/application/form/ExtraOptionsView.vue'),
    beforeEnter: (to, from, next) => {
      // console.log(store.getters['ELA/GET_S_YMD']);
      if (store.getters['ELA/GET_APP_MENU'].applCd === '22') {
        if (
          !store.getters['ELA/GET_S_YMD'] ||
          !store.getters['ELA/GET_E_YMD']
        ) {
          alert('일자를 선택해주세요.');
          window.history.go(-2);
          return;
        }
      }
      next();
    },
  },
  // 연차계획작성
  {
    name: routerConstants.AnnualPlanWrite,
    path: '/annualPlanWrite',
    component: () => import('@/views/application/AnnualPlanWriteView.vue'),
  },
  // 연차계획목록
  {
    name: routerConstants.AnnualPlan,
    path: '/annualPlan',
    component: () => import('@/views/application/AnnualPlanView.vue'),
  },

  // 신청완료 뷰
  {
    name: routerConstants.ApplicationConfirm,
    path: '/applicationConfirm',
    component: () => import('@/views/application/ApplicationConfirmView.vue'),
    beforeEnter: (to, from, next) => {
      // 결재선 화면에서만 접근가능
      if (from.name === routerConstants.ApprovalLine) {
        next();
      } else {
        // 신청완료 후 신청완료뷰어 접근 시 메인으로 이동
        router.push(routerConstants.Main);
        return;
      }
    },
  },
];
